module.exports = __webpack_public_path__ + "6d82b6c7404e2df14d2b07d2210e38ed.svg";